import { CommerceNoteResults, CommerceNoteSearchOptions, CommerceNoteSearchParams } from '@atlassian/cssxp-types-audit';
import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';
import { EntitlementDefaultsRequest, EntitlementDefaultsResponse } from '@atlassian/cssxp-types-entitlement';

const client = createAxiosClient({ baseURL: '/api/1/entitlements' }, ServiceProxyMap.ANS);

export async function fetchCommerceNotes(
  entitlementKey: string,
  params: Omit<CommerceNoteSearchParams, 'entitlementKey'> & CommerceNoteSearchOptions
): Promise<CommerceNoteResults> {
  const response = await client.get(`/${encodeURIComponent(entitlementKey)}/notes`, {
    params,
  });
  return response.data;
}
export async function changeRenewalAction(accountId: string, requestPayload: any): Promise<void> {
  await client.post(`${accountId}/renewal-action`, requestPayload);
}

export async function getEntitlementDefaults(
  requestPayload: EntitlementDefaultsRequest
): Promise<EntitlementDefaultsResponse> {
  const response = await client.post('/defaults', requestPayload);
  return response.data;
}

export async function getUserTierForEntitlement(requestPayload: any) {
  const response = await client.post('/userTier', requestPayload);
  return response.data;
}
